export default {
    methods: {
        onInvalidSubmit({ values, errors }) {
            //Focus first invalid field
            var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
            firstInvalidField[0].focus();
        },
        async updateQuantity(event, st_code) {
            this.emitter.emit('isLoading', true);

            let vm = this;
            var quantity = event.target.value;

            if (st_code != null && st_code != false) {
                st_code = st_code.replace('#', '%23');
            }

            await axios.post('/ajax/update_basket_tyre_quantity/' + quantity + '/' + st_code)
            .then(response => {
                if(response.data.basket_updated == true)
                {
                    this.emitter.emit('refreshBasket');

                    this.emitter.emit('refreshServices', response.data.basket_services);
                }
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
            
            this.emitter.emit('isLoading', false);
        },
    }
};